import React, { useState } from "react";
import { doSendVerifyType, doVerifyType, doResendOtp } from "@AUTH";
import { Form, Input, Button, Statistic, Modal, Row, Col, Result } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
const { Countdown } = Statistic;
const VerifyEmail = ({ email, setIsEmailAddressVerified, setVerifyType }) => {
  const [visible, setVisible] = useState(true);
  const [emailForm] = Form.useForm();
  const [emailTimerFinished, setEmailTimerFinished] = useState(false);
  const [expiresAtStringEmail, setExpireAtStringEmail] = useState(null);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [verificationEmail, setVerificationEmail] = useState(null);

  const sendEmail = async () => {
    try {
      setLoading(true);
      emailForm.validateFields().then(async (values) => {
        const verification = await doSendVerifyType({
          email,
          verifyType: "EMAIL",
        });

        if (verification) {
          setExpireAtStringEmail(verification?.expiresAt.toLocaleString());
          setVerificationEmail(verification);
        }
      });
      // SMS gönderme işlemi burada
    } catch (err) {
      console.error("Form validation error:", err);
    } finally {
      setLoading(false);
    }
  };

  const verifyEmail = async (val) => {
    try {
      setLoading(true);
      const verification = await doVerifyType({
        verificationId: verificationEmail.verificationId,
        verificationCode: val?.verificationCode,
      });
      if (verification?.success) {
        setIsEmailVerified(true);
        setIsEmailAddressVerified(true);
        setStep(1);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const onEmailTimerFinish = () => {
    setEmailTimerFinished(true);
  };
  const resendOtp = async () => {
    try {
      setLoading(true);
      const payload = {
        verificationId: verificationEmail.verificationId,
      };
      const response = await doResendOtp(payload);
      if (response) {
        setVerificationEmail(response);
        setExpireAtStringEmail(response.expiresAt.toLocaleString());
        setEmailTimerFinished(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const steps = [
    {
      title: "Bilgilendirme ve doğrulama",
      content: (
        <Row gutter={16}>
          <Col span={24}>
            <Form
              layout="vertical"
              name="basic"
              onFinish={(val) => sendEmail(val)}
              style={{ width: "100%" }}
              form={emailForm}
            >
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    name={"email"}
                    initialValue={email}
                    label="E-posta Adresi:"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen e-posta adresinizi giriniz!",
                      },
                    ]}
                  >
                    <Input placeholder="E-posta adresiniz" disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  {isEmailVerified ? (
                    <h4
                      style={{
                        color: "green",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginTop: 34,
                      }}
                    >
                      <CheckCircleOutlined />
                      Doğrulandı
                    </h4>
                  ) : (
                    <Form.Item>
                      <Button
                        block
                        style={{ marginTop: 30 }}
                        type="primary"
                        htmlType="submit"
                        disabled={verificationEmail}
                      >
                        Doğrulama kodu gönder
                      </Button>
                    </Form.Item>
                  )}
                </Col>
              </Row>
            </Form>
            {verificationEmail && !isEmailVerified && (
              <Form
                layout="vertical"
                name="basic"
                onFinish={(val) => verifyEmail(val)}
                style={{ width: "100%" }}
              >
                <Row gutter={16}>
                  <Col span={10}>
                    <Form.Item
                      name="verificationCode"
                      label="Doğrulama kodunuz:"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject(
                                "Lütfen doğrulama kodunu giriniz."
                              );
                            }

                            // OTP'nin 6 haneli olması gerektiğini kontrol et
                            if (value.length !== 6) {
                              return Promise.reject(
                                "Doğrulama kodu 6 haneli olmalıdır."
                              );
                            }

                            // OTP'nin sadece rakamlardan oluşması gerektiğini kontrol et
                            if (!/^\d{6}$/.test(value)) {
                              return Promise.reject(
                                "Doğrulama kodu yalnızca rakamlardan oluşmalıdır."
                              );
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input maxLength={6} style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{
                        marginTop: 28,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                      }}
                    >
                      Kalan süre:
                      <Countdown
                        value={expiresAtStringEmail}
                        format="mm:ss"
                        onFinish={() => onEmailTimerFinish()}
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <Form.Item>
                      {emailTimerFinished ? (
                        <Button
                          type="primary"
                          onClick={resendOtp}
                          block
                          loading={loading}
                          style={{
                            marginTop: 28,
                          }}
                          disabled={!emailTimerFinished}
                        >
                          Kodu Yeniden Gönder
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          loading={loading}
                          style={{
                            marginTop: 28,
                          }}
                          disabled={emailTimerFinished}
                        >
                          Kodu Doğrula
                        </Button>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )}

            {/* <Row align="end">
              <Button
                type="primary"
                disabled={!isEmailVerified}
                onClick={() => setStep(1)}
              >
                İlerle
              </Button>
            </Row> */}
          </Col>
        </Row>
      ),
    },

    {
      title: "Sonuç",
      content: (
        <Result
          status={isEmailVerified ? "success" : "error"}
          title={"Doğrulama başarılı"}
          extra={[
            isEmailVerified && (
              <span key="email" style={{ color: "#52c41a" }}>
                ✔ E-posta adresiniz doğrulandı
              </span>
            ),
          ]}
        />
      ),
    },
  ];

  return (
    <Modal
      visible={visible}
      closable={true}
      title={"E-posta bilgisi doğrulama"}
      width={750}
      centered
      maskClosable={true}
      footer={null}
      onCancel={() => {
        setVisible(false);
        setVerifyType(null);
      }}
    >
      {steps[step].content}
    </Modal>
  );
};

export default VerifyEmail;
